import { useEffect } from 'react';
import type { IFramework } from '../../framework';

/** 鼠标按下/抬起时与键盘操作态协同（透传禁用态） */
export function useKeyboardMouseSync(framework: IFramework) {
    useEffect(() => {
        const mouseDownHandle = framework.service.editor.onMouseDown(() => {
            const isDisablePick = framework.service.editor.disablePick;
            if (isDisablePick) return true;
            const isDisableOperate = framework.service.editor.disableOperate;
            if (isDisableOperate) return true;
        }, 8);

        const mouseUpHandle = framework.service.editor.onMouseUp(() => {
            const isDisablePick = framework.service.editor.disablePick;
            if (isDisablePick) return true;
            const isDisableOperate = framework.service.editor.disableOperate;
            if (isDisableOperate) return true;
        }, 8);

        return () => {
            framework.service.events.off(mouseDownHandle);
            framework.service.events.off(mouseUpHandle);
        };
    }, []);
}
